import React from "react";

export const FormVoluntario = ({ form, handleChange }) => {
  const especialidades = [
    "Cocina",
    "Albañilería",
    "Electricidad",
    "Mecánica",
    "Chofer",
    "Limpieza",
    "Fotografía",
    "Multimedia",
    "Enfermería",
    "Músico",
    "Social Media",
    "Seguridad",
    "Otros-Varios",
  ];

  return (
    <div className="row">
      <div className="col-12">
        <div
          className="p-4 rounded-4 shadow-sm"
          style={{
            background: "linear-gradient(135deg,#eef4ff,#ffffff)",
            border: "3px solid rgba(13,110,253,0.2)",
          }}
        >
          <h5
            className="fw-bold"
            style={{
              color: "#0d6efd",
            }}
          >
            Información para Voluntarios
          </h5>

          <p className="mb-0 text-muted fs-5">
            Participa y colabora en las diferentes actividades durante, el
            seminario, entrenamiento y reporte, no participa del proyecto o
            viaje, su trabajo suma a la organización del evento. mayores de 22
            años y puede elegir en que etapa participar. Al termino de su
            inscripción le llegara a su whatsapp un mensaje para coordinar su
            entrevista virtual o presencial.
          </p>
        </div>
      </div>
      {/* NOMBRE */}
      <div className="col-md-6 mb-3">
        <br></br>
        <label className="form-label fw-semibold">Primer Nombre</label>

        <input
          type="text"
          className="form-control form-control-lg rounded-4"
          name="nombre"
          value={form.nombre}
          onChange={handleChange}
          required
        />
      </div>

      {/* APELLIDO */}
      <div className="col-md-6 mb-3">
        <br></br>
        <label className="form-label fw-semibold">Apellido Paterno</label>

        <input
          type="text"
          className="form-control form-control-lg rounded-4"
          name="apellido"
          value={form.apellido}
          onChange={handleChange}
          required
        />
      </div>

      {/* CELULAR */}
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Celular</label>

        <input
          type="text"
          className="form-control form-control-lg rounded-4"
          name="celular"
          value={form.celular}
          onChange={handleChange}
          required
        />
      </div>

      {/* IGLESIA */}
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Iglesia</label>

        <input
          type="text"
          className="form-control form-control-lg rounded-4"
          name="iglesia"
          value={form.iglesia}
          onChange={handleChange}
          required
        />
      </div>

      {/* ESPECIALIDAD */}
      <div className="col-12 mb-4">
        <label className="form-label fw-semibold">Serviré en la siguiente área:</label>

        <select
          className="form-select form-select-lg rounded-4"
          name="especialidad"
          value={form.especialidad}
          onChange={handleChange}
          required
        >
          <option value="">Seleccione una especialidad</option>

          {especialidades.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      {/* EXPERIENCIA */}
      <div className="col-12 mb-4">
        <label className="form-label fw-semibold">
          Si elegiste la opción OTROS O VARIOS:
        </label>

        <textarea
          className="form-control rounded-4"
          rows="4"
          name="comentario"
          value={form.comentario}
          onChange={handleChange}
          placeholder="Comentanos cómo deseas ayudar..."
        ></textarea>
      </div>

      {/* INFO */}
    </div>
  );
};
